import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
var polygon = "";
var mapInstance = "";
export default {
  name: "BusinessAOI",
  data: function data() {
    return {
      visible: false,
      title: "",
      from: {},
      polygonOptions: {
        fillOpacity: 0.4,
        fillColor: "black",
        strokeStyle: "solid",
        strokeColor: "blue",
        strokeWeight: 2,
        strokeOpacity: 1
      },
      aoiData: [],
      jsonAoi: []
    };
  },
  beforeMount: function beforeMount() {},
  methods: {
    close: function close() {
      var _mapInstance;
      (_mapInstance = mapInstance) === null || _mapInstance === void 0 || _mapInstance.removeOverlay(polygon);
      mapInstance = "";
      polygon = "";
      this.from = {};
      this.aoiData = [];
    },
    edit: function edit(row, title, cityName) {
      var _row$location,
        _this = this;
      this.visible = true;
      this.from = row || {};
      this.title = title;
      this.aoiData = (row === null || row === void 0 || (_row$location = row.location) === null || _row$location === void 0 || (_row$location = _row$location.coordinates) === null || _row$location === void 0 ? void 0 : _row$location[0]) || [];
      this.jsonAoi = this.aoiData.length ? JSON.stringify(this.aoiData) : "";
      this.$nextTick(function () {
        _this.initMap(cityName);
      });
    },
    initMap: function initMap(cityName) {
      var _this$aoiData;
      mapInstance = new BMap.Map("map-view");
      // 默认使用第一个点作为中心
      var first = ((_this$aoiData = this.aoiData) === null || _this$aoiData === void 0 ? void 0 : _this$aoiData[0]) || [];
      if (first.length) {
        mapInstance.centerAndZoom(new BMap.Point(first[0], first[1]), 12);
      } else {
        mapInstance.centerAndZoom(cityName);
      }
      var zoomControl = new BMap.NavigationControl({
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        type: BMAP_NAVIGATION_CONTROL_ZOOM
      });
      mapInstance.addControl(zoomControl);
      mapInstance.enableScrollWheelZoom();
      if (this.aoiData.length) {
        this.addOverlay();
      }
    },
    parseCoords: function parseCoords(arr) {
      var pts = [];
      arr.forEach(function (item) {
        if (item.length === 2) {
          var lng = item[0],
            lat = item[1];
          if (!isNaN(lng) && !isNaN(lat)) {
            pts.push(new BMap.Point(lng, lat));
          }
        }
      });
      return pts;
    },
    addOverlay: function addOverlay() {
      if (polygon) {
        mapInstance.addOverlay(polygon);
      } else {
        var pts = this.parseCoords(this.aoiData);
        polygon = new BMap.Polygon(pts, this.polygonOptions);
        mapInstance.addOverlay(polygon);
        polygon.enableEditing();
      }
      mapInstance.setViewport(polygon.getPath());
    },
    //保存
    save: function save() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var aoi, location, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              aoi = _this2.exportPoint();
              location = {
                coordinates: [],
                type: "Polygon"
              };
              if (aoi.length) {
                location.coordinates = [aoi];
              }
              _context.n = 1;
              return _this2.$api.updateBusinessAOIV3({
                id: _this2.from.id,
                location: location
              });
            case 1:
              res = _context.v;
              if (res.data) {
                _this2.$message.success("更新 AOI 成功");
                _this2.visible = false;
                _this2.$emit("reload");
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    //导出数据
    exportPoint: function exportPoint() {
      if (!polygon) {
        this.$message.warning("请先添加或更新覆盖物");
        return;
      }
      var path = polygon.getPath().slice(); // 复制一份

      var out = path.map(function (pt) {
        return [pt.lng, pt.lat];
      });
      return out;
    },
    //设置 aoi 数据
    setBusinessAOI: function setBusinessAOI() {
      var aoi = JSON.parse(this.jsonAoi);
      var pts = this.parseCoords(aoi);
      if (pts.length < 3) {
        this.$message.warning("至少需要3个坐标点");
        return;
      }
      if (polygon) {
        mapInstance.removeOverlay(polygon);
      }
      polygon = new BMap.Polygon(pts, this.polygonOptions);
      mapInstance.addOverlay(polygon);
      polygon.enableEditing();
      mapInstance.setViewport(polygon.getPath());
    }
  }
};